import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
import { roundNumber, roundNumber0 } from "./tools";

const TIMEZONE = "Asia/Ho_Chi_Minh";

const toNonAccentVietnamese = function (str) {
  str = str.replace(/A|Á|À|Ã|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/Đ/g, "D");
  str = str.replace(/đ/g, "d");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  return str;
};

export const normalize = function (string) {
  let str = String(string).toLowerCase();
  return toNonAccentVietnamese(str);
};

export const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = moment(dateString, [
    "DD/MM/YYYY",
    "YYYY-MM-DD",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    "MM/DD/YYYY",
  ]).tz(TIMEZONE);

  if (!date.isValid()) return "Invalid date";

  return date.format("DD/MM/YYYY");
};

export const formatDateForInput = (dateString) => {
  if (!dateString) {
    return ""; // Trả về chuỗi rỗng nếu không có giá trị đầu vào
  }

  const date = moment(dateString, [
    "YYYY-MM-DD", // Định dạng ISO ngắn
    "YYYY-MM-DDTHH:mm:ssZ", // ISO đầy đủ
    "DD/MM/YYYY", // Định dạng ngày tháng
    "MM/DD/YYYY", // Định dạng Mỹ
  ]).tz(TIMEZONE);

  if (!date.isValid()) {
    return "";
  }

  return date.format("YYYY-MM-DD");
};

export function delay(timeout) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}

export const isEndTimeGreater = (start, end) => {
  const [startHour, startMinute] = start.split(":").map(Number);
  const [endHour, endMinute] = end.split(":").map(Number);

  const startTimeInMinutes = startHour * 60 + startMinute;
  const endTimeInMinutes = endHour * 60 + endMinute;

  return endTimeInMinutes > startTimeInMinutes;
};

export const isEndDateGreater = (start, end) => {
  if (!start || !end) return false;

  const startDate = new Date(start);
  const endDate = new Date(end);

  return endDate > startDate;
};

// export const customDateTimeFormat = (timestamp) => {
//   if (timestamp === "" || timestamp === "_" || timestamp === "-") {
//     return timestamp;
//   }
//   const date = new Date(timestamp);

//   const hours = date.getUTCHours().toString().padStart(2, "0");
//   const minutes = date.getUTCMinutes().toString().padStart(2, "0");
//   const day = date.getUTCDate().toString().padStart(2, "0");
//   const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
//   const year = date.getUTCFullYear();

//   const formattedDate = `${hours}:${minutes} ${day}/${month}/${year}`;
//   return formattedDate;
// };

// export const customDateFormat = (timestamp) => {
//   if (timestamp === "" || timestamp === "_" || timestamp === "-") {
//     return timestamp;
//   }
//   const date = new Date(timestamp);

//   const day = date.getUTCDate().toString().padStart(2, "0");
//   const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
//   const year = date.getUTCFullYear();

//   const formattedDate = `${day}/${month}/${year}`;
//   return formattedDate;
// };

export const customDateTimeFormat = (timestamp) => {
  if (
    !timestamp ||
    timestamp === "" ||
    timestamp === "_" ||
    timestamp === "-"
  ) {
    return timestamp;
  }

  const date = new Date(timestamp);

  const formattedDate = date.toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour12: false,
  });

  return formattedDate.replace(",", "");
};

export const customDateFormat = (timestamp) => {
  if (
    !timestamp ||
    timestamp === "" ||
    timestamp === "_" ||
    timestamp === "-"
  ) {
    return timestamp;
  }

  const date = new Date(timestamp);

  return date.toLocaleDateString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const customDateFormatType = (timestamp) => {
  if (timestamp === "" || timestamp === "_" || timestamp === "-") {
    return timestamp;
  }

  const date = new Date(timestamp);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const customDateFormatType2 = (timestamp) => {
  if (timestamp === "" || timestamp === "_" || timestamp === "-") {
    return timestamp;
  }
  const date = new Date(timestamp);

  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const customDateFormatType3 = (timestamp) => {
  if (timestamp === "" || timestamp === "_" || timestamp === "-") {
    return timestamp;
  }

  const date = new Date(timestamp);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

export const restoreDateFromFormatted = (dateString) => {
  if (!dateString || typeof dateString !== "string") return null;
  // Tạo lại Date object từ chuỗi yyyy-MM-dd
  const restoredDate = new Date(dateString);
  return restoredDate;
};

export const formatDateToLocal = (date) => {
  const d = new Date(date);
  if (isNaN(d.getTime())) return ""; // Trả về rỗng nếu không phải ngày hợp lệ

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const generateCodeFromName = (name) => {
  if (!name) return "";
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "_")
    .toUpperCase();
};

export const formatDateToUTC = (dateString) => {
  const date = new Date(dateString);
  date.setHours(date.getHours() - 7); // Điều chỉnh múi giờ GMT+7 về UTC

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

//bỏ dấu
export const removeAccents = (str) => {
  const accents = [
    { base: "a", letters: /[áàảãạăắằẳẵặâấầẩẫậ]/g },
    { base: "e", letters: /[éèẻẽẹêếềểễệ]/g },
    { base: "i", letters: /[íìỉĩị]/g },
    { base: "o", letters: /[óòỏõọôốồổỗộơớờởỡợ]/g },
    { base: "u", letters: /[úùủũụưứừửữự]/g },
    { base: "y", letters: /[ýỳỷỹỵ]/g },
    { base: "d", letters: /[đ]/g },
  ];

  accents.forEach(({ base, letters }) => {
    str = str.replace(letters, base);
  });

  return str;
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export function formatNumber(number) {
  return number.toLocaleString("en-US");
}

export function formatNumberUS(number) {
  return number.toLocaleString("en-US");
}

export function formatNumberStyle(number) {
  let [integer, decimal] = number.toString().split(".");
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimal ? `${integer}.${decimal}` : integer;
}

export function formatCash(str) {
  return str
    .split("")
    .reverse()
    .reduce((prev, next, index) => {
      return (index % 3 ? next : next + ".") + prev;
    });
}

export const formatPrice = (price) => {
  const formatPrice = roundNumber0(price);
  return new Intl.NumberFormat("en-DE").format(formatPrice);
};

export const formatPriceUS = (price) => {
  const formatPrice = roundNumber0(price);
  // Chuẩn hóa số 0 âm (-0, hoặc số âm rất nhỏ bị làm tròn về -0) -> 0,
  // tránh hiển thị "-0". Không đổi giá trị/luồng vì -0 === 0.
  return new Intl.NumberFormat("en-US").format(formatPrice === 0 ? 0 : formatPrice);
};

export const formatPriceUSData = (price) => {
  const safePrice = Math.abs(price) < 1e-3 ? 0 : price;
  return new Intl.NumberFormat("en-US").format(safePrice);
};

export const formatPriceUSFloat = (price) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(Number(price));
};

export const formatNumberFloat = (number) => {
  if (number % 1 === 0) {
    return number;
  }
  const decimalPart = number.toString().split(".")[1];
  if (decimalPart && decimalPart.length > 2) {
    return parseFloat(number.toFixed(2));
  }
  return number;
};

export const checkTokenExpiration = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000); // Lấy thời gian hiện tại (tính bằng giây)

    return decoded.exp > currentTime; // true nếu token còn hạn, false nếu hết hạn
  } catch (error) {
    return false; // Nếu token không hợp lệ, coi như hết hạn
  }
};

export const convertDate = (dateStr) => {
  // Ghim đúng NGÀY theo lịch về 00:00:00 UTC để KHÔNG lệch 1 ngày khi lưu DB /
  // hiển thị theo múi giờ. Cách cũ moment(...).utc() biến 00:00 giờ VN thành
  // 17:00Z hôm trước -> lệch ngày.
  // Parse bằng moment.utc + nhiều định dạng để idempotent: dù đầu vào là
  // "30/06/2025", "2025-06-30" (đã qua importFile) hay ISO thì đều ra cùng ngày.
  // Trùng định dạng với BE normalizeDateOnlyToUTC.
  const m = moment.utc(dateStr, [
    "DD/MM/YYYY",
    "D/M/YYYY",
    "YYYY-MM-DD",
    moment.ISO_8601,
  ]);
  if (!m.isValid()) return "";
  return `${m.format("YYYY-MM-DD")}T00:00:00.000Z`;
};

// Có thẻ HTML thật hay không (đã không bị escape)
export const hasRealHtml = (s = "") => /<\s*[a-z][\s\S]*>/i.test(s);

// Chuẩn hoá: text/plain hoặc HTML bị escape -> HTML hiển thị đúng
export const normalizeDescription = (raw = "") => {
  if (!raw) return "";

  // 1) Trả về ngay nếu đã là HTML thật
  if (hasRealHtml(raw)) return raw;

  // 2) Nếu là HTML bị escape (&lt;p&gt;…) -> decode
  const textarea = document.createElement("textarea");
  textarea.innerHTML = raw;
  const decoded = textarea.value; // &lt;p&gt; -> <p>

  if (hasRealHtml(decoded)) return decoded;

  // 3) Nếu chỉ là text có \n -> chuyển sang <p> / <br>
  const text = decoded.replace(/\r\n/g, "\n");
  const paragraphs = text
    .split(/\n{2,}/) // dòng trống -> đoạn mới
    .map((block) => block.split("\n").join("<br>"));

  return `<p>${paragraphs.join("</p><p>")}</p>`;
};

// Giải mã HTML entities (&lt; &gt; &amp; ...)
export const decodeHtml = (raw = "") => {
  const ta = document.createElement("textarea");
  ta.innerHTML = raw;
  return ta.value;
};

// Chuyển HTML/escaped HTML/plain text => plain text đẹp để hiển thị tóm tắt
export const htmlToPlainPreview = (raw, opts) => {
  const { maxLength = 0, keepNewlines = true } = opts || {};
  if (!raw) return "";

  // 1) decode nếu đang ở dạng &lt;p&gt;...
  let s = decodeHtml(raw);

  // 2) chuyển <a href="...">text</a> -> "text (url)"
  s = s.replace(/<a [^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi, (_, href, text) => {
    // xoá thẻ lồng trong text của a
    const textNoTag = String(text).replace(/<[^>]+>/g, "");
    // return `${textNoTag} (${href})`;
    return `${textNoTag}`;
  });

  // 3) thay block/line breaks thành xuống dòng
  s = s
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|h[1-6]|blockquote)>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<\/li>/gi, "\n")
    .replace(/<\/ul>|<\/ol>/gi, "\n");

  // 4) bỏ mọi thẻ HTML còn lại
  s = s.replace(/<[^>]+>/g, "");

  // 5) dọn khoảng trắng
  s = s
    .replace(/\u00A0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  // 6) nếu không muốn giữ xuống dòng ở list/table, đổi \n -> space
  if (!keepNewlines) s = s.replace(/\n+/g, " ");

  // 7) cắt ngắn
  if (maxLength && s.length > maxLength) s = s.slice(0, maxLength - 1) + "…";

  return s;
};

export const FormatMoneyToThousands = (money) => {
  const rounded = Math.round(money / 1000) * 1000;
  return rounded.toLocaleString("en-US");
};

export const numberFixed = (number, n) => {
  return Number(number.toFixed(n));
};
